import { useEffect, useState } from "react";
import api from "@/lib/api";
import RaffleCard from "@/components/RaffleCard";
import { Search, Loader2 } from "lucide-react";

export default function RafflesList() {
    const [raffles, setRaffles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [q, setQ] = useState("");

    useEffect(() => {
        setLoading(true);
        api.get("/raffles", { params: { status: "approved" } })
            .then((r) => setRaffles(r.data))
            .finally(() => setLoading(false));
    }, []);

    const filtered = raffles.filter((r) =>
        (r.title + " " + r.prize + " " + r.description).toLowerCase().includes(q.toLowerCase())
    );

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="raffles-list-page">
            <div className="mb-10 flex flex-col md:flex-row md:items-end justify-between gap-4">
                <div>
                    <div className="text-xs uppercase tracking-[0.3em] font-bold opacity-60 mb-2">Catálogo</div>
                    <h1 className="font-display font-black text-5xl sm:text-6xl uppercase tracking-tight">Rifas activas</h1>
                </div>
                <div className="relative w-full md:w-80">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" strokeWidth={3} />
                    <input
                        type="text"
                        placeholder="Buscar rifa o premio…"
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        className="brut-input pl-10"
                        data-testid="search-input"
                    />
                </div>
            </div>

            {loading ? (
                <div className="flex justify-center py-20">
                    <Loader2 className="w-10 h-10 animate-spin" />
                </div>
            ) : filtered.length === 0 ? (
                <div className="brut-card p-12 text-center" data-testid="no-results">
                    <p className="font-display font-black text-2xl">No hay rifas que coincidan.</p>
                    <p className="text-ink/70 mt-2">Prueba con otro término de búsqueda.</p>
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filtered.map((r) => (
                        <RaffleCard key={r.id} raffle={r} />
                    ))}
                </div>
            )}
        </div>
    );
}
